import axios from './index';

import type { ApiResponse } from './dramas';

export type UgcReportTargetType = 'WORK' | 'DRAMA' | 'USER' | 'COMMENT';
export type UgcReportWorkKind = 'SHORT_VIDEO' | 'DRAMA_EPISODE';
export type UgcReportTimePreset = 'LAST_7_DAYS' | 'LAST_30_DAYS' | 'CUSTOM';

export interface UgcReportUser {
    id?: string;
    nickname?: string | null;
    avatar_url?: string | null;
    email?: string | null;
    wallet_address?: string | null;
    [property: string]: unknown;
}

export interface UgcReportBelongingWork {
    id?: string;
    title?: string | null;
    episode_no?: string | number | null;
    drama_id?: string | null;
    type?: string | null;
    cover_url?: string | null;
    hls_url?: string | null;
    video_url?: string | null;
    [property: string]: unknown;
}

export interface UgcReportLog {
    id: string;
    ticket_id?: string;
    target_type?: UgcReportTargetType;
    target_id?: string;
    reporter_user_id?: string;
    report_type_code?: string;
    description?: string | null;
    created_at?: string | number | null;
    reporter?: UgcReportUser | null;
    reporter_name?: string | null;
    [property: string]: unknown;
}

export interface UgcReportTicket {
    id: string;
    target_type: UgcReportTargetType;
    target_id: string;
    work_kind?: UgcReportWorkKind | null;
    drama_id?: string | null;
    episode_id?: string | null;
    comment_id?: string | null;
    author_user_id?: string | null;
    report_count?: number;
    first_reported_at?: string | number | null;
    last_reported_at?: string | number | null;
    created_at?: string | number | null;
    updated_at?: string | number | null;
    logs?: UgcReportLog[];
    author?: UgcReportUser | null;
    belonging_work?: UgcReportBelongingWork | null;
    comment_user?: UgcReportUser | null;
    target?: Record<string, unknown> | null;
    [property: string]: unknown;
}

export interface UgcReportListParams {
    target_type: UgcReportTargetType;
    page?: number;
    size?: number;
    report_time?: UgcReportTimePreset;
    /** ISO datetime range when report_time=CUSTOM */
    reported_at?: string[];
    report_type_code?: string;
    work_kind?: UgcReportWorkKind;
    work_id?: string;
    work_name?: string;
    drama_id?: string;
    drama_name?: string;
    reported_user_id?: string;
    reported_user_nickname?: string;
    comment_id?: string;
    comment_user_id?: string;
    comment_user_nickname?: string;
    belonging_work_id?: string;
    belonging_work_name?: string;
    author_user_id?: string;
    author_name?: string;
    reporter_user_id?: string;
    reporter_nickname?: string;
}

export const ugcReportList = (
    params: UgcReportListParams,
    config?: { signal?: AbortSignal },
) =>
    axios<ApiResponse<UgcReportTicket[]>>('/v1/ugc-reports', {
        method: 'get',
        params,
        signal: config?.signal,
    });
